import Swal from 'sweetalert2';

const alert = Swal.mixin({});

export const Alert = (success = true, message = '', duration = 6000) => {
    let type;
    if (typeof success === 'boolean') {
        type = success ? 'success' : 'error';
    } else {
        type = success;
    }

    alert.fire({
        icon: type,
        title: message,
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: duration,
        timerProgressBar: true,
        iconColor: 'white',
        customClass: {
            popup: 'gral-toast__popup',
            container: 'gral-toast',
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
            toast.addEventListener('click', Swal.close);
        },
    });
};

function divFunction(coord){
    console.log(coord);
}
